/** Tracks async lifecycle for Redux fields backed by API requests. */
export type RequestState<T> = {
  status: "loading" | "success" | "failure";
  data: T | undefined;
};

export const requestState = {
  loading<T>(): RequestState<T> {
    return { status: "loading", data: undefined };
  },
  success<T>(data: T): RequestState<T> {
    return { status: "success", data };
  },
  failure<T>(): RequestState<T> {
    return { status: "failure", data: undefined };
  },
};

export function isRequestLoading<T>(
  state: RequestState<T> | undefined
): state is RequestState<T> & { status: "loading" } {
  return state?.status === "loading";
}

export function isRequestSuccess<T>(
  state: RequestState<T> | undefined
): state is RequestState<T> & { status: "success" } {
  return state?.status === "success";
}

export function isRequestFailed<T>(
  state: RequestState<T> | undefined
): state is RequestState<T> & { status: "failure" } {
  return state?.status === "failure";
}
